import React from 'react'
import { Portal } from 'react-portal'
import { type ModalContextProps, useModalContext } from './ModalContext'
import { AlloyModal } from './index'
import { type Size } from '@adsk/alloy-react-modal/es/Modal'

interface ModalUnitProps {
	content?: JSX.Element
	style?: object
	props?: object
}

interface StyleProps {
	overlayStyle?: React.CSSProperties
}

export interface StepProps {
	size?: Size
	root?: {
		props?: object
		styles?: StyleProps
	}
	body?: ModalUnitProps
	footer?: ModalUnitProps
	header?: ModalUnitProps & {
		closeAction?: boolean
	}
}

interface ModalProps {
	steps: StepProps[]
	styles?: StyleProps
}

const StepModal: React.FC<ModalProps> = ({ steps, styles }) => {
	const { isOpen, step, closeModal } = useModalContext() as ModalContextProps
	const totalSteps = steps.length
	const currentStep = steps[Math.min(Math.max(step, 0), totalSteps - 1)]
	return (
		<Portal>
			<AlloyModal
				open={isOpen}
				size={currentStep.size ?? AlloyModal.SIZES.SMALL}
				shouldCloseOnOverlayClick
				shouldCloseOnEsc
				/* Current Step Style priority will be higher than the overall modal */
				overlayStyle={
					currentStep?.root?.styles?.overlayStyle ?? styles?.overlayStyle
				}
				{...currentStep?.root?.props}
			>
				{currentStep.header !== undefined && (
					<AlloyModal.Header {...currentStep.header?.props}>
						{currentStep.header?.content}
						{currentStep.header?.closeAction === true && (
							<AlloyModal.Close aria-label="close" onClick={closeModal} />
						)}
					</AlloyModal.Header>
				)}
				{currentStep.body !== undefined && (
					<AlloyModal.Body {...currentStep.body?.props}>
						{currentStep.body?.content}
					</AlloyModal.Body>
				)}
				{currentStep.footer !== undefined && (
					<AlloyModal.Footer {...currentStep.footer.props}>
						{currentStep.footer.content}
					</AlloyModal.Footer>
				)}
			</AlloyModal>
		</Portal>
	)
}

export default StepModal
